<template>
    <div  v-if="themeStore.themeIndex == 1">
    <vipView :data-set="dataSet" @vIPClaim="VIPClaim" v-model:active="active"/>
    </div>
    <div  v-if="themeStore.themeIndex == 2">
    <vipViewTwo :data-set="dataSet" @vIPClaim="VIPClaim" v-model:active="active"/>
    </div>
    <div  v-if="themeStore.themeIndex == 3">
    <vipViewThree :data-set="dataSet" @vIPClaim="VIPClaim" v-model:active="active" :is-tab-view="isTabView"/>
    </div>
    <div v-if="themeStore.themeIndex == 4">
        <vipViewFour :data-set="dataSet" @vIPClaim="VIPClaim" v-model:active="active" :is-tab-view="isTabView" />
    </div>
    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>
<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { getVIPClaim, getVIPRewardInfo } from '@/api/activity';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { useUserStore } from '@/stores/user';
import { VipData } from '@/view/vip/supportScript';
import vipView from '@/themes/themeOne/vip/vipView.vue';
import vipViewTwo from '@/themes/themeTwo/vip/vipView.vue';
import vipViewThree from '@/themes/themeThree/vip/vipView.vue';
import vipViewFour from '@/themes/themeFour/vip/vipView.vue';
import { useThemeStore } from '@/stores/theme';
const props = defineProps<{
    isTabView?: boolean
}>()
const themeStore = useThemeStore()
const userStore = useUserStore()
const currentLevel = ref(0)
const remainRewards = ref(0)
const progressPercentage = computed(() => 6500 * 100 / 10000);
const { t } = useI18n();
const active = ref(0);
const statusRef = ref();
const toastContent = ref('');
const isSuccess = ref(false);
const loadingRef = ref();
const vipConfigData = ref()
const VIPRewardsInfo = ref<any>({})
const nextLevel = ref(0)
const nextLevelRecord = ref<any>({})
const activity_intro = ref([])

const tabelData = ref([])
const bannerIcon = ref('')
const dataSet = computed<VipData>(() => ({
    currentLevel: currentLevel.value,
    remainRewards: remainRewards.value,
    VIPRewardsInfo: VIPRewardsInfo.value,
    nextLevelRecord: nextLevelRecord.value,
    nextLevel: nextLevel.value,
    active: active.value,
    tabelData: tabelData.value,
    vipConfigData: vipConfigData.value,
    activity_intro: activity_intro.value,
    bannerIcon: bannerIcon.value,
}))
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}

const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const getVIPData = () => {
    loadingRef.value.open();
    getVIPRewardInfo().then((res: any) => {
        loadingRef.value.close();
        if (res.data) {
            activity_intro.value = JSON.parse(res.data?.activityIntro)
            bannerIcon.value = res.data?.floatIcon
            remainRewards.value = res.data?.reward
            VIPRewardsInfo.value = res.data?.vipRewardInfo
            currentLevel.value = VIPRewardsInfo.value?.currentVIPLevel
            const highestVipLevel = VIPRewardsInfo.value?.highestVipLevel
            if (currentLevel.value < highestVipLevel) {
                // user still has next level
                nextLevel.value = VIPRewardsInfo.value?.nextVipLevel
            } else {
                // user already at highest level
                nextLevel.value = highestVipLevel
            }

            vipConfigData.value = JSON.parse(res.data?.config)
            nextLevelRecord.value = vipConfigData.value?.level_list.find(
                (item: any) => item.level === nextLevel.value
            )
            tabelData.value = vipConfigData.value?.level_list
    }
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const VIPClaim = () => {
    if (remainRewards.value > 0) {
        loadingRef.value.open();
        let data = {
        uid: userStore.id
    }
        getVIPClaim(data).then((res: any) => {
            loadingRef.value.close();
            showSuccess(res.msg)
            getVIPData()
        }).catch(err => {
            if (err.code != 401) {
                loadingRef.value.close();
                showError(err);
            }
        })
    }
}

onMounted(() => [
    getVIPData()
])
</script>

